import React from 'react';
import { StyledNavLink, NavLinksWrapper } from './NavigationLinks.Styes';
import { NavigationSearch } from '../../molecules/NavigationSearch/NavigationSearch';
import { useIsDesktopOrLaptop, 
  useIsMiniNotebook, 
  useIsMobileBig, 
  useIsMobileMedium, 
  useIsMobileMini 
  } from '../../../styles/theme'

  interface BlogSectionProps {
    tag?: string;
    onSearch?: (tag: string) => void;
  }
  const foo = () => {
    console.log('No search function provided');
  };

  export const NavigationLinks : React.FC<BlogSectionProps> = ({ onSearch }) => {

  const breakpoints = {
    isDesktopOrLaptop: useIsDesktopOrLaptop(),
    isMiniNotebook: useIsMiniNotebook(),
    isMobileBig: useIsMobileBig(),
    isMobileMedium: useIsMobileMedium(),
    isMobileMini: useIsMobileMini(),
  };
      

return(
<NavLinksWrapper
      isMobileMini={useIsMobileMini()}
      isMobileMedium={useIsMobileMedium()}
      isMobileBig={useIsMobileBig()}
      isMiniNotebook={useIsMiniNotebook()}
      isDesktopOrLaptop={useIsDesktopOrLaptop()}
    >
    <StyledNavLink 
      to="/nutricao"
      className={({ isActive }) => (isActive ? 'active' : '')}

      isMobileMini={useIsMobileMini()}
      isMobileMedium={useIsMobileMedium()}
      isMobileBig={useIsMobileBig()}
      isMiniNotebook={useIsMiniNotebook()}
    >
      Nutrição
    </StyledNavLink >
    <StyledNavLink 
      to="/exercicios"
      className={({ isActive }) => (isActive ? 'active' : '')}

      isMobileMini={useIsMobileMini()}
      isMobileMedium={useIsMobileMedium()}
      isMobileBig={useIsMobileBig()}
      isMiniNotebook={useIsMiniNotebook()}
    >
      Exercícios
    </StyledNavLink >
    <StyledNavLink 
      to="/menteecorpo"
      className={({ isActive }) => (isActive ? 'active' : '')}

      isMobileMini={useIsMobileMini()}
      isMobileMedium={useIsMobileMedium()}
      isMobileBig={useIsMobileBig()}
      isMiniNotebook={useIsMiniNotebook()}
    >
      Mente e Corpo
    </StyledNavLink >
    <StyledNavLink 
      to="/produtos"
      className={({ isActive }) => (isActive ? 'active' : '')}

      isMobileMini={useIsMobileMini()}
      isMobileMedium={useIsMobileMedium()}
      isMobileBig={useIsMobileBig()}
      isMiniNotebook={useIsMiniNotebook()}
    >
      Produtos
    </StyledNavLink >
    <StyledNavLink 
      to="/noticias"
      className={({ isActive }) => (isActive ? 'active' : '')}

      isMobileMini={useIsMobileMini()}
      isMobileMedium={useIsMobileMedium()}
      isMobileBig={useIsMobileBig()}
      isMiniNotebook={useIsMiniNotebook()}
    >
      Notícias
    </StyledNavLink >
    {(breakpoints.isMobileMini ) && (
    <NavigationSearch onSearch={onSearch || foo} />)}
  </NavLinksWrapper>

  )
}